import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutMain from '../views/layout/Main.vue'
import auth from '../middleware/auth'
import i18n from "@/i18n";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/rwp',
    },
    {
        path: '/',
        component: LayoutMain,
        meta: {},
        children: [
            {
                path: '/rwp',
                name: 'RedirectWithPermission',
                component: () => import('../views/pages/RedirectWithPermission'),
                meta: {
                    permissions: [],
                    middleware: [auth],
                    pageName: '',
                    title: '',
                },
            },
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('../views/pages/Dashboard'),
                meta: {
                    permissions: [],
                    middleware: [auth],
                    pageName: '',
                    title: '',
                },
            },
            {
                path: '/change-password',
                name: 'ChangePassword',
                component: () => import('../views/pages/account/ChangePassword.vue'),
                meta: {
                    permissions: [],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đổi mật khẩu'),
                    title: i18n.t('Đổi mật khẩu'),
                },
            },
            {
                path: '/timekeeping',
                name: 'Timekeeping',
                component: () => import('../views/pages/account/Timekeeping.vue'),
                meta: {
                    permissions: [],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Chấm công'),
                    title: i18n.t('Chấm công'),
                },
            },
            {
                path: '/account',
                name: 'Account',
                component: () => import('../views/pages/account/Index.vue'),
                meta: {
                    permissions: ['e_account'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Tài khoản'),
                    title: i18n.t('Tài khoản'),
                },
            },
            {
                path: '/order',
                name: 'Order',
                component: () => import('../views/pages/order/Index.vue'),
                meta: {
                    permissions: ['e_order'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đơn hàng'),
                    title: i18n.t('Đơn hàng'),
                },
            },
            {
                path: '/rent-branch',
                name: 'RentBranch',
                component: () => import('../views/pages/rent/Branch.vue'),
                meta: {
                    permissions: ['e_rent_branch'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Cho thuê'),
                    title: i18n.t('Cho thuê'),
                },
            },
            {
                path: '/rent-support',
                name: 'RentSupport',
                component: () => import('../views/pages/rent/Support.vue'),
                meta: {
                    permissions: ['rent_support'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đặt hộ xe'),
                    title: i18n.t('Đặt hộ xe'),
                },
            },
            {
                path: '/rent-collaborator',
                name: 'RentCollaborator',
                component: () => import('../views/pages/rent/Collaborator.vue'),
                meta: {
                    permissions: ['rent_collaborator'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đặt xe'),
                    title: i18n.t('Đặt xe'),
                },
            },
            {
                path: '/rent-collaborator-offline',
                name: 'RentCollaboratorOffline',
                component: () => import('../views/pages/rent/CollaboratorOffline.vue'),
                meta: {
                    permissions: ['rent_collaborator_offline'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đặt xe'),
                    title: i18n.t('Đặt xe'),
                },
            },
            {
                path: '/rent-agency',
                name: 'RentAgency',
                component: () => import('../views/pages/rent/Agency.vue'),
                meta: {
                    permissions: ['rent_agency'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đặt xe'),
                    title: i18n.t('Đặt xe'),
                },
            },
            {
                path: '/rent-contract',
                name: 'RentContract',
                component: () => import('../views/pages/rent/Contract.vue'),
                meta: {
                    permissions: ['rent_contract'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đặt xe'),
                    title: i18n.t('Đặt xe'),
                },
            },
            {
                path: '/rent-delivery',
                name: 'RentDelivery',
                component: () => import('../views/pages/rent/Delivery.vue'),
                meta: {
                    permissions: ['e_rent_delivery', 'e_delivery'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Giao đi - Lấy về - Thu hồi'),
                    title: i18n.t('Giao đi - Lấy về - Thu hồi'),
                },
            },
            {
                path: '/branch-delivery',
                name: 'BranchDelivery',
                component: () => import('../views/pages/rent/BranchDelivery.vue'),
                meta: {
                    permissions: ['e_rent_branch', 'e_rent_delivery', 'e_delivery'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Giao xe tại cửa hàng'),
                    title: i18n.t('Giao xe tại cửa hàng'),
                },
            },
            {
                path: '/exchange',
                name: 'Exchange',
                component: () => import('../views/pages/exchange/Index.vue'),
                meta: {
                    permissions: ['e_exchange'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đổi xe'),
                    title: i18n.t('Đổi xe'),
                },
            },
            {
                path: '/prepair',
                name: 'Prepair',
                component: () => import('../views/pages/prepair/Index.vue'),
                meta: {
                    permissions: ['e_prepair'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Chuẩn bị'),
                    title: i18n.t('Chuẩn bị'),
                },
            },
            {
                path: '/renewal',
                name: 'Renewal',
                component: () => import('../views/pages/renewal/Index.vue'),
                meta: {
                    permissions: ['e_renewal'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Gia hạn'),
                    title: i18n.t('Gia hạn'),
                },
            },
            {
                path: '/settlement',
                name: 'Settlement',
                component: () => import('../views/pages/settlement/Index.vue'),
                meta: {
                    permissions: ['e_settlement'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Trả xe'),
                    title: i18n.t('Trả xe'),
                },
            },
            {
                path: '/delivery-request-partner',
                name: 'DeliveryRequestPartner',
                component: () => import('../views/pages/rent/DeliveryRequestPartner.vue'),
                meta: {
                    permissions: [
                        'rent_collaborator',
                        'rent_collaborator_offline',
                        'rent_agency',
                        'rent_contract',
                    ],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Trả xe'),
                    title: i18n.t('Trả xe'),
                },
            },
            {
                path: '/renewal-partner',
                name: 'RenewalPartner',
                component: () => import('../views/pages/renewal/Partner.vue'),
                meta: {
                    permissions: [
                        'rent_collaborator',
                        'rent_collaborator_offline',
                        'rent_agency',
                        'rent_contract',
                    ],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Gia hạn'),
                    title: i18n.t('Gia hạn'),
                },
            },
            {
                path: '/order-partner',
                name: 'OrderPartner',
                component: () => import('../views/pages/order/Partner.vue'),
                meta: {
                    permissions: [
                        'rent_collaborator',
                        'rent_collaborator_offline',
                        'rent_agency',
                        'rent_contract',
                    ],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Đơn hàng - Đối tác - CTV'),
                    title: i18n.t('Đơn hàng - Đối tác - CTV'),
                },
            },
            {
                path: '/commission-policy',
                name: 'CommissionPolicy',
                component: () => import('../views/pages/CommissionPolicy.vue'),
                meta: {
                    permissions: [
                        'rent_collaborator',
                        'rent_collaborator_offline',
                        'rent_agency',
                    ],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Chính sách hoa hồng'),
                    title: i18n.t('Chính sách hoa hồng'),
                },
            },
            {
                path: '/price',
                name: 'PriceContract',
                component: () => import('../views/pages/PriceContract.vue'),
                meta: {
                    permissions: [
                        'rent_contract',
                    ],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Bảng giá'),
                    title: i18n.t('Bảng giá'),
                },
            },
            {
                path: '/delivery-request',
                name: 'DeliveryRequest',
                component: () => import('../views/pages/rent/DeliveryRequest.vue'),
                meta: {
                    permissions: [
                        'e_delivery_request',
                    ],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Cần xử lý'),
                    title: i18n.t('Cần xử lý'),
                },
            },
            {
                path: '/print-pdf',
                name: 'PrintPDF',
                component: () => import('../views/pages/PrintPdf.vue'),
                meta: {
                    permissions: ['e_print_pdf'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('In hợp đồng - phụ lục'),
                    title: i18n.t('In hợp đồng - phụ lục'),
                },
            },
            {
                path: '/generate-pdf',
                name: 'GeneratePDF',
                component: () => import('../views/pages/GeneratePdf.vue'),
                meta: {
                    permissions: ['e_generate_stamp'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Tạo tem'),
                    title: i18n.t('Tạo tem'),
                },
            },
            {
                path: '/invoice',
                name: 'Invoice',
                component: () => import('../views/pages/order/Invoice.vue'),
                meta: {
                    permissions: ['e_invoice'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Hóa đơn'),
                    title: i18n.t('Hóa đơn'),
                },
            },
            {
                path: '/inventory',
                name: 'Inventory',
                component: () => import('../views/pages/asset/Inventory.vue'),
                meta: {
                    permissions: ['e_inventory'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Kiểm kê'),
                    title: i18n.t('Kiểm kê'),
                },
            },
            {
                path: '/payroll',
                name: 'Payroll',
                component: () => import('../views/pages/payroll/Index.vue'),
                meta: {
                    permissions: ['e_payroll'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Lương'),
                    title: i18n.t('Lương'),
                },
            },
            {
                path: '/test-payment-qr',
                name: 'TestPaymentQr',
                component: () => import('../views/pages/TestPaymentQr.vue'),
                meta: {
                    permissions: ['super_admin'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Test QR'),
                    title: i18n.t('Test QR'),
                },
            },
            {
                path: '/get-items',
                name: 'GetAssetByName',
                component: () => import('../views/pages/asset/GetAssetByName.vue'),
                meta: {
                    permissions: ['super_admin'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Get items'),
                    title: i18n.t('Get items'),
                },
            },
            {
                path: '/fake-payment',
                name: 'FakePayment',
                component: () => import('../views/pages/FakePayment.vue'),
                meta: {
                    permissions: ['super_admin'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Fake payment'),
                    title: i18n.t('Fake payment'),
                },
            },
            /**
             * End Account
             */

            /**
             * Hoa don
             */
            /* {
                path: '/invoice',
                name: 'Invoice',
                component: () => import('../views/pages/invoice/Index'),
                meta: {
                    permissions: ['administration_invoice'],
                    modules: [],
                    middleware: [auth],
                    pageName: i18n.t('Hóa đơn'),
                    title: i18n.t('Hóa đơn'),
                },
            }, */
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/pages/Login.vue'),
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/pages/Contact.vue'),
    },
    {
        path: '/contact/:tracking',
        name: 'Contact',
        component: () => import('../views/pages/Contact.vue'),
    },
    {
        path: '/403',
        name: 'Error403',
        component: () => import('../views/pages/errors/403.vue'),
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('../views/pages/Register.vue'),
    },
    {
        path: '/booking',
        name: 'Booking',
        pageName: i18n.t('Booking'),
        title: i18n.t('Booking'),
        meta: {
            permissions: [],
            modules: [],
            pageName: i18n.t('Booking'),
            title: i18n.t('Booking'),
        },
        component: () => import('../views/pages/rent/Booking.vue'),
    },
    {
        path: '/booking/:tracking',
        name: 'Booking',
        pageName: i18n.t('Booking'),
        title: i18n.t('Booking'),
        meta: {
            permissions: [],
            modules: [],
            pageName: i18n.t('Booking'),
            title: i18n.t('Booking'),
        },
        component: () => import('../views/pages/rent/Booking.vue'),
    },
]


const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
});

router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title ? `${to.meta.title} | ${process.env.VUE_APP_TITLE}` : process.env.VUE_APP_TITLE;
    });
});

export default router
